module.exports = __webpack_public_path__ + "static/img/1050.019e1ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1050.jpg
// module id = 232
// module chunks = 0